module.exports = __webpack_public_path__ + "public/images/icon-ok.755903a1d05b9f559d0f23e15d994089.svg";